import React, { FC, ReactNode } from 'react'

interface SectionCardProps {
  title?: ReactNode
  children: ReactNode
  style?: React.CSSProperties
}

const TITLE_STYLE: React.CSSProperties = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '24px',
  color: '#5F5F5F',
  marginBottom: 8,
}

const BASE_STYLE: React.CSSProperties = {
  background: '#fff',
  borderRadius: 2,
  padding: '20px 24px',
  border: '1px solid #F0F0F0',
}

const SectionCard: FC<SectionCardProps> = ({ title, children, style }) => (
  <div style={{ marginBottom: 16 }}>
    {title && <div style={TITLE_STYLE}>{title}</div>}
    <div style={{ ...BASE_STYLE, ...style }}>{children}</div>
  </div>
)

export default SectionCard
